import axios from "axios";
import {API_URL} from "../constants";
import {authHeader} from "../Utilities";
import {StatusCount} from "./ApiModels/BackgroundTasks";

class BackgroundTasksService {
    async globalStatus(): Promise<StatusCount[]> {
        const response = await axios.get<StatusCount[]>(
            API_URL + `/background_tasks/status`,
            {headers: authHeader()}
        );
        return response.data;
    }
}

export default new BackgroundTasksService();